<template>
  <div>
    <button
      v-b-tooltip.hover
      v-b-modal="'updateExistingEntry' + entryToEditId"
      type="button"
      placement="bottom"
      title="Bearbeiten"
      class="btn btn-primary smallActionButton"
      @click="showModal = true"
    >
      <i class="fas fa-edit" />
    </button>
    <b-modal
      v-if="showModal"
      :id="'updateExistingEntry' + entryToEditId"
      :ref="'updateExistingEntry' + entryToEditId"
      no-fade
      hide-footer
      size="xl"
      title="Feed-Eintrag bearbeiten"
    >
      <div class="d-block mb-4">
        <u-error-handling
          v-if="errorObject"
          :error-object="errorObject"
          :property-mapping="createErrorPropertyMappings()"
        />
        <u-loader v-show="isLoading" />
        <div v-show="!isLoading">
          <EditFeedEntry
            v-if="existingEntry"
            v-model="existingEntry"
            :editable="editable"
          />
        </div>
        <b-button
          variant="success"
          @click="saveEntry()"
        >
          Speichern
        </b-button>
        <b-button
          class="ml-2"
          variant
          @click="hideModal"
        >
          Abbrechen
        </b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import EditFeedEntry from "@/components/rssFeed/EditFeedEntry.vue";
import {
  UpdateFeedEntry,
  GetSingleFeedEntry,
} from "@/services/rssFeed.service.js";
export default {
  components: {
    EditFeedEntry,
  },
  props: {
    entryToEditId: {
      type: Number,
      required: true,
    },
    editable: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showModal: false,
      existingEntry: null,
      isLoading: false,
      errorObject: null,
      allLanguages: [
        { name: "Deutsch", value: "de-CH" },
        { name: "Französisch", value: "fr-CH" },
        { name: "Italienisch", value: "it-CH" },
      ],
    };
  },
  watch: {
    showModal(newValue) {
      if (newValue) {
        this.loadExistingEntry();
      }
    },
  },
  created() {},
  methods: {
    hideModal() {
      this.$refs["updateExistingEntry" + this.entryToEditId].hide();
    },
    loadExistingEntry() {
      this.isLoading = true;
      this.errorObject = null;

      GetSingleFeedEntry(
        this.entryToEditId,
        (response) => {
          this.existingEntry = response;
          this.isLoading = false;
        },
        (error) => {
          this.errorObject = error;
          this.isLoading = false;
        },
      );
    },
    saveEntry() {
      this.isLoading = true;
      this.errorObject = null;

      UpdateFeedEntry(
        this.existingEntry.id,
        this.existingEntry,
        () => {
          this.isLoading = false;
          this.hideModal();
          this.$emit("updatedEntry");
        },
        (error) => {
          this.errorObject = error;
          this.isLoading = false;
        },
      );
    },
    createErrorPropertyMappings() {
      var mapping = {};

      this.allLanguages.map((language, index) => {
        mapping[`FeedEntryContents[${index}].Url`] = `Url ${language.name}`;
      });

      this.allLanguages.map((language, index) => {
        mapping[`FeedEntryContents[${index}].Title`] = `Titel ${language.name}`;
      });

      this.allLanguages.map((language, index) => {
        mapping[`FeedEntryContents[${index}].Text`] = `Text ${language.name}`;
      });

      return mapping;
    },
  },
};
</script>

<style scoped>
.smallActionButton {
  width: 25px;
  height: 25px;
  font-size: 17px;
  padding: 0px;
}
</style>
